export default {
    root: {
        fontSize: '14px'
    }
  };
  